import { render, staticRenderFns } from "./IconCircleArrowRight.vue?vue&type=template&id=0854fcd3&scoped=true"
import script from "./IconCircleArrowRight.vue?vue&type=script&lang=js"
export * from "./IconCircleArrowRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854fcd3",
  null
  
)

export default component.exports